import { Node, mergeAttributes } from "@tiptap/core";

export const CustomDiv = Node.create({
	name: "customBlockElement",
	group: "block",
	content: "block*",

	addAttributes() {
		return {
			tag: {
				default: "div",
				parseHTML: element => element.tagName.toLowerCase(),
				renderHTML: attributes => ({ tag: attributes.tag })
			},
			style: {
				default: "",
				parseHTML: element => element.getAttribute("style"),
				renderHTML: attributes => ({ style: attributes.style })
			},
			class: {
				default: "",
				parseHTML: element => element.getAttribute("class"),
				renderHTML: attributes => ({ class: attributes.class })
			},
			id: {
				default: "",
				parseHTML: element => element.getAttribute("id"),
				renderHTML: attributes => ({ id: attributes.id })
			},
			"data-*": {
				default: {},
				parseHTML: element => {
					const dataAttrs = {};
					Array.from(element.attributes).forEach(attr => {
						if (attr.name.startsWith("data-")) {
							dataAttrs[attr.name] = attr.value;
						}
					});
					return dataAttrs;
				},
				renderHTML: attributes => attributes["data-*"]
			},
			attrs: {
				default: {},
				parseHTML: element => {
					const allAttrs = {};
					Array.from(element.attributes).forEach(attr => {
						if (
							!["tag", "style", "class", "id"].includes(attr.name) &&
							!attr.name.startsWith("data-")
						) {
							allAttrs[attr.name] = attr.value;
						}
					});
					return allAttrs;
				},
				renderHTML: attributes => attributes.attrs
			}
		};
	},

	parseHTML() {
		return [
			{
				tag: "*",
				getAttrs: element => {
					const attrs = {
						tag: element.tagName.toLowerCase()
					};

					Array.from(element.attributes).forEach(attr => {
						attrs[attr.name] = attr.value;
					});

					switch (element.tagName.toLowerCase()) {
						case "div":
						case "p":
						case "h1":
						case "h2":
						case "h3":
						case "h4":
						case "h5":
						case "h6":
							attrs.style = element.getAttribute("style") || "";
							attrs.class = element.getAttribute("class") || "";
							attrs.id = element.getAttribute("id") || "";
							break;
						case "img":
							attrs.src = element.getAttribute("src") || "";
							attrs.alt = element.getAttribute("alt") || "";
							attrs.width = element.getAttribute("width") || "";
							attrs.height = element.getAttribute("height") || "";
							break;
						case "iframe":
							attrs.src = element.getAttribute("src") || "";
							attrs.width = element.getAttribute("width") || "";
							attrs.height = element.getAttribute("height") || "";
							break;
						default:
							break;
					}

					return attrs;
				}
			}
		];
	},

	renderHTML({ node, HTMLAttributes }) {
		const tag = node.attrs.tag || "div";
		const allAttributes = {
			...node.attrs.attrs,
			...node.attrs["data-*"],
			style: node.attrs.style,
			class: node.attrs.class,
			id: node.attrs.id
		};
		return [tag, mergeAttributes(allAttributes, HTMLAttributes), 0];
	},

	addProseMirrorPlugins() {
		return [];
	}
});